const checkAuth = () => {
    if (localStorage.getItem('token') !== null) return true;
    return false;
  }

export default checkAuth;